module.exports = __webpack_public_path__ + "img/HTIT-WB32.222c86ed.jpg";